import { sendClose } from 'reactApp/modules/integration/communicator';
import { getIntegrationState } from 'reactApp/modules/integration/integration.selectors';
import type { IntegrationState } from 'reactApp/modules/integration/integration.types';
import { select } from 'redux-saga/effects';

export function* handleCancel() {
    const { parentOrigin }: IntegrationState = yield select(getIntegrationState);
    sendClose(parentOrigin);
}
